export default {
  "region": "eu-west-2",
  "darwin_halo_host_name": "app.halo.sauce.construction",
  "darwin_user_pool_arn": "arn:aws:cognito-idp:eu-west-2:573925613571:userpool/eu-west-2_tJZNxAINu",
  "darwin_user_pool_client_id": "5und1haptni0isfsnj29khks2l",
  "darwin_user_pool_endpoint": "cognito-idp.eu-west-2.amazonaws.com/eu-west-2_tJZNxAINu",
  "darwin_user_pool_id": "eu-west-2_tJZNxAINu",
  "diagnostics_api_endpoint": "https://diagnostics.halo.sauce.construction",
  "halo_api_endpoint": "https://api.halo.sauce.construction",
  "halo_websocket_api_endpoint": "wss://ws.halo.sauce.construction",
  "logic_iot_endpoint": "aufycq5rw5u6n-ats.iot.eu-west-2.amazonaws.com",
  "sentry_env": "dev"
} // 11/5/2026, 2:00:16 PM